import { Helmet } from '@dr.pogodin/react-helmet'
import { useTranslation } from "react-i18next";
import { useParams } from 'react-router-dom';
import { name } from '../utils/constants';
import { FAVICON } from "../lib/config";
import logo from "../assets/icons/favicon.png";

export const Meta = ({ title, description, image }) => {
    const { MODE } = import.meta.env;
    const { t } = useTranslation();
    const { language } = useParams();

    const _language = language === "am" ? "hy" : "en";
    const _title = title ? `${t(title)} | ${name}` : name;
    const _description = t(description);
    const _logo = MODE === "development" ? logo : FAVICON;
    const _image = image ?? _logo;
    const _url = typeof window !== "undefined" ? window.location.href : "";

    return (
        <Helmet>
            <html lang={_language} />
            <title>{_title}</title>
            <meta name="title" content={_title} />
            <meta name="description" content={_description} />

            {/* Open Graph / Facebook  */}
            <meta property="og:type" content="website" />
            <meta property="og:image" content={_image} />
            <meta property="og:image:secure_url" content={_image} />
            <meta property="og:image:alt" content="Favicon" />
            <meta property="og:title" content={_title} />
            <meta property="og:description" content={_description} />
            <meta property="og:url" content={_url} />
            <meta property="og:site_name" content={name.toLocaleLowerCase()} />

            {/* Twitter */}
            <meta name="twitter:creator" content={name} />
            <meta name="twitter:card" content="website" />
            <meta name="twitter:url" content={_url} />
            <meta name="twitter:title" content={_title} />
            <meta name="twitter:description" content={_description} />

            <link rel="canonical" href={_url} />
            <link rel="manifest" href={`/manifest.${language}.json`} />

            <meta property="fb:app_id" content="1515145726365018" />

            {/* Google tag (gtag.js) */}
            <meta name="google-site-verification" content="google-site-verification=yrrODCyTa30wLsafgf3RYLxSuP2QJLEEDolS5L74K0E" />

            <script
                async
                src="https://www.googletagmanager.com/gtag/js?id=G-YS1301KB5J"
            ></script>
            <script>
                {`
                window.dataLayer = window.dataLayer || [];
                function gtag() {
                    dataLayer.push(arguments);}
                gtag("js", new Date());

                gtag("config", "G-YS1301KB5J");
                `}
            </script>
        </Helmet>
    )
}
